export const tabsId = 'tabs';
